import { Card, Typography, Stack, Button, Box, Divider } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";
import { FormInput } from "@/components/forms/FormInput";
import { FormUnits } from "@/features/units/components/FormUnits";
import { NutritionProfileForm } from "@/features/settings/components/NutritionProfileForm";
import { useUpdateProfileMutation, useGetProfileQuery } from "@/features/onboarding/api";
import { yupResolver } from "@hookform/resolvers/yup";
import { profileSchema } from "@/features/onboarding/schema";
import { useSearchParams } from "react-router-dom";

export function SettingsPersonalPage() {
  const { isFetching, data } = useGetProfileQuery();
  const [saveProfile, saveResult] = useUpdateProfileMutation();

  function save(data) {
    saveProfile({ data });
  }

  return (isFetching ? 'Loading...' : <SettingsPersonalForm data={data.data.profile} save={save} saveResult={saveResult} />);    
}

function SettingsPersonalForm({ data, save, saveResult }) {
  const [searchParams] = useSearchParams();
  const shouldAddProfile = searchParams.get('addNutritionProfile') === 'true';
  const form = useForm({
    defaultValues: data,
    resolver: yupResolver(profileSchema),
  });

  return (    
    <Card variant="outlined" sx={{ p: 2.5 }}>      
      <Box sx={{ mb: 2 }}>
        <Typography level="h4">Personal Preferences</Typography>
        <Typography level="body-sm">Customize your profile and preferred settings</Typography>
      </Box>

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(save)}>
          <Stack gap={4}>
            <FormInput name="display_name" label="Display Name" placeholder="Your name" />            
            <FormUnits />                             
          </Stack>
          <Stack gap={3} sx={{ mt: 3, mb: 1 }}>
            <Divider />
            <NutritionProfileForm autoAdd={shouldAddProfile} />
          </Stack>       
          <Button loading={saveResult.isLoading} type="submit" sx={{mt: 3}}>Save Changes</Button>
        </form>
      </FormProvider>         
    </Card>
  );
}

